import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, { ReactNode, ReactNodeArray } from 'react';
import IdfMainPageBlockData from '../../../Models/Content/IdfMainPageBlockData';
import IdfMainPage from './IdfMainPage';

export default class IdfMainPageBlock extends EpiComponent<IdfMainPageBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <IdfMainPage context={this.getContext()} iContent={this.props.data} />;
  }
}
